const upgradeDnsTitle = 'Upgrading from OTCID - Disclosure & News Service';
const upgradeOtcqbTitle = 'Upgrading from OTCQB';
const reapplyOtcqxTitle = 'Reapplying for OTCQX';
const reapplyOtcqbTitle = 'Reapplying for OTCQB';

export const paymentTitles = {
    ACH: 'ACH Payment (U.S. Bank)',
    CREDIT_CARD: 'Credit Card Payment',
    OFFLINE: 'Offline Payment (Wire Transfer or Check)',
};

export const taxableStates = {
    CT: 'CT',
    DC: 'DC',
    'DISTRICT OF COLUMBIA': 'DC',
    DISTRICT_OF_COLUMBIA: 'DISTRICT OF COLUMBIA',
    CONNECTICUT: 'CONNECTICUT',
};

export const taxUsaStates = [taxableStates.CT, taxableStates.DC];

export const feeDescriptions = (isOTCID, appTypeName) => [
    {
        text: `The ${appTypeName} Application Fee is non-refundable and must be paid prior to submission of this application.`,
    },
    {
        text: isOTCID
            ? 'Annual Fee payments will be refunded if the application is denied.'
            : 'Invoice for annual fee will be sent to Billing Contact(s) upon approval of application.',
    },
];

export const reducedFeeTypes = {
    UPGRADE_FROM_OTCQB: 'UPGRADE_FROM_OTCQB',
    UPGRADE_FROM_DNS: 'UPGRADE_FROM_DNS',
    REAPPLY_OTCQX: 'REAPPLY_OTCQX',
    REAPPLY_OTCQB: 'REAPPLY_OTCQB'
};

export const reducedFeesDescOtcqx = new Map([
    [reducedFeeTypes.UPGRADE_FROM_DNS, upgradeDnsTitle],
    [reducedFeeTypes.UPGRADE_FROM_OTCQB, upgradeOtcqbTitle],
    [reducedFeeTypes.REAPPLY_OTCQX, reapplyOtcqxTitle]
]);

export const reducedFeesOptionsOtcqx = [{
    id: reducedFeeTypes.UPGRADE_FROM_DNS,
    title: upgradeDnsTitle,
    fee: 2500,
    desc: 'The Company subscribed to OTCID and paid the OTCID Application Fee in the last 12 months. Eligible for a reduced fee.'
}, {
    id: reducedFeeTypes.UPGRADE_FROM_OTCQB,
    title: upgradeOtcqbTitle,
    fee: 0,
    desc: 'The Company is trading on OTCQB and paid the OTCQB Application Fee in the last 12 months. Application Fee is waived.'
}, {
    id: reducedFeeTypes.REAPPLY_OTCQX,
    title: reapplyOtcqxTitle,
    fee: 0,
    desc: 'The Company is reapplying for OTCQX and paid the OTCQX Application Fee in the last 12 months. Application Fee is waived.'
}
];

export const reducedFeesOptionsOtcqb = [{
    id: reducedFeeTypes.UPGRADE_FROM_DNS,
    title: upgradeDnsTitle,
    fee: 2500,
    desc: 'The Company subscribed to OTCID and paid the OTCID Application Fee in the last 12 months. Eligible for a reduced fee.'
}, {
    id: reducedFeeTypes.REAPPLY_OTCQB,
    title: reapplyOtcqbTitle,
    fee: 0,
    desc: 'The Company is reapplying for OTCQB and paid the OTCQB Application Fee in the last 12 months. Application Fee is waived.'
}
];

export const reducedFeesDescOtcqb = new Map([
    [reducedFeeTypes.UPGRADE_FROM_DNS, upgradeDnsTitle],
    [reducedFeeTypes.REAPPLY_OTCQB, reapplyOtcqbTitle]
]);
export const reducedFeeOtcqxSectionTitle = 'Companies that are upgrading their service or reapplying for OTCQX may be eligible for a reduced Application Fee.';
export const reducedFeeOtcqbSectionTitle = 'Companies that have paid an application fee to OTC Markets Group within the last 12 months may be eligible for a reduced Application Fee.';
export const reducedFeeTitle = 'Eligibility for Reduced Application Fee';